/**
 * Constantes y configuraciones para el módulo Roles
 */

/**
 * Límites de validación para campos de formulario
 */
export const LIMITES_VALIDACION = {
    NOMBRE_MAX: 100,
    DESCRIPCION_MAX: 500,
} as const;

/**
 * Mensajes de error estandarizados
 */
export const MENSAJES_ERROR = {
    NOMBRE_REQUERIDO: 'El nombre es requerido',
    NOMBRE_EXCEDE_LIMITE: `El nombre no puede exceder ${LIMITES_VALIDACION.NOMBRE_MAX} caracteres`,
    DESCRIPCION_EXCEDE_LIMITE: `La descripción no puede exceder ${LIMITES_VALIDACION.DESCRIPCION_MAX} caracteres`,

    // Errores genéricos
    ERROR_CARGAR: 'Error al cargar roles',
    ERROR_CREAR: 'Error al crear rol',
    ERROR_ACTUALIZAR: 'Error al actualizar rol',
    ERROR_ELIMINAR: 'Error al eliminar rol',

    // Mensajes de éxito
    CREADO_EXITOSO: 'Rol creado exitosamente',
    ACTUALIZADO_EXITOSO: 'Rol actualizado exitosamente',
    ELIMINADO_EXITOSO: 'Rol eliminado exitosamente',
} as const;

/**
 * Textos de la interfaz de usuario
 */
export const TEXTOS_UI = {
    CONFIRMAR_ELIMINACION_TITULO: '¿Estás seguro de que deseas eliminar el rol',
    ADVERTENCIA_PREFIJO: 'Atención:',
    ADVERTENCIA_USUARIOS: 'Este rol tiene',
    ADVERTENCIA_SUFIJO: 'usuario(s) asociado(s).',
    NO_PUEDE_ELIMINAR: 'No se puede eliminar mientras tenga usuarios asociados.',
    NOTA_ELIMINACION: 'Esta acción no puede deshacerse.',
    BOTON_ELIMINANDO: 'Eliminando...',
    BOTON_ELIMINAR: 'Eliminar',
    CARGANDO_DATOS: 'Cargando datos...',
} as const;
